
import { Star } from "lucide-react";

export function SocialProof() {
  return (
    <section className="py-10 bg-muted/30">
      <div className="container">
        <div className="text-center mb-6">
          <div className="flex justify-center mb-2">
            {[1, 2, 3, 4, 5].map((star) => (
              <Star key={star} className="h-5 w-5 text-yellow-500 fill-yellow-500" />
            ))}
          </div>
          <p className="text-lg font-medium">4.8/5 average rating from 142 users</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          <div className="bg-background p-5 rounded-lg shadow-sm border">
            <p className="mb-3 italic text-muted-foreground">"Hour Tracker simplified my invoicing process and helped me get paid 30% faster."</p>
            <div className="font-medium">Sarah K.</div>
            <div className="text-sm text-muted-foreground">Freelance Designer</div>
          </div>
          
          <div className="bg-background p-5 rounded-lg shadow-sm border">
            <p className="mb-3 italic text-muted-foreground">"The best free time tracking tool I've found after trying over a dozen paid options."</p>
            <div className="font-medium">Michael T.</div>
            <div className="text-sm text-muted-foreground">Web Developer</div>
          </div>
          
          <div className="bg-background p-5 rounded-lg shadow-sm border">
            <p className="mb-3 italic text-muted-foreground">"Simple to use, yet powerful enough for all my client projects. Highly recommended!"</p>
            <div className="font-medium">Jessica M.</div>
            <div className="text-sm text-muted-foreground">Content Writer</div>
          </div>
        </div>
        
        <div className="flex flex-wrap justify-center items-center gap-8 mt-10 text-muted-foreground">
          <div className="text-lg font-semibold">Trusted by freelancers from:</div>
          <div className="font-medium">Upwork</div>
          <div className="font-medium">Fiverr</div>
          <div className="font-medium">Freelancer.com</div>
          <div className="font-medium">99designs</div>
          <div className="font-medium">Toptal</div>
        </div>
      </div>
    </section>
  );
}
